import { Decoder, field, number, string, succeed } from 'jsonous';
import { typeaheadResourceDecoder } from '../TypeaheadInput/Decoders';
import { GroupSuggestion, GroupSuggestionsResource } from './Types';

const groupSuggestionDecoder: Decoder<GroupSuggestion> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string));

export const groupSuggestionsResourceDecoder: Decoder<GroupSuggestionsResource> =
  typeaheadResourceDecoder(groupSuggestionDecoder);
